class Shop {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.drawerInner = document.querySelector('.cart-drawer__inner');
    this.body = document.querySelector('body');
    this.menuCartCount = document.querySelector('.js-menu-cart-count');
    this.drawerOverlay = document.querySelector('.js-drawer-overlay');
    this.drawerOpenItems = document.querySelectorAll('.js-drawer-open');

    const productForms = document.querySelectorAll('.shopify-product-form');
    productForms.forEach((form) => {
      form.addEventListener('submit', (e) =>{
        e.preventDefault();
        this.addToCart(form);
      })
    })

    this.drawerOpenItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openDrawer();
      })
    });

    // it's not updated so it's loaded once
    this.drawerOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeDrawer();
    });

    this.drawerTriggers();

    this.isCart();
  }

  isCart()  {
    if(window.location.href.includes('?cart')){
      this.openDrawer();
    }
  }

  addToCart(form) {
    const formData = new FormData(form);
    this.loader(true);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(response.status) {
          new Notify({
            status: 'error',
            title: response.message,
            text: response.description,
            autoclose: false,
            autotimeout: 3000,
          })
        } else {
          this.reloadDrawer();
          this.openDrawer()
        }
        this.loader(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.loader(false);
      });
  }

  drawerTriggers() {

    // Remove line item
    const removeItems = this.drawer.querySelectorAll('.js-remove');
    if (removeItems.length > 0) {
      removeItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const formData = {
            'updates': {
              [e.target.dataset.key]: 0
            }
          }
          this.updateItem(formData);
        })
      });
    }

    // Close drawer
    const closeDrawerItems = this.drawer.querySelectorAll('.js-drawer-close');
    if (closeDrawerItems.length > 0) {
      closeDrawerItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeDrawer();
        })
      });
    }

    // Remove line item
    document.querySelectorAll('.js-qty-spinner').forEach((item) => {
      const input = item.querySelector('input');
      const up = item.querySelector('.up');
      const down = item.querySelector('.down');
      let debounceTimer;

      const updateQty = () => {
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        debounceTimer = setTimeout(() => {
          const formData = {
            'updates': {
              [input.dataset.key]: input.value
            }
          }
          this.updateItem(formData);
        }, 500);
      };

      up.addEventListener('click', (e) => {
        input.value = parseFloat(input.value) + 1;
        input.dispatchEvent(new Event('change'));
        updateQty();
      });

      down.addEventListener('click', (e) => {
        if (parseFloat(input.value) > 1) {
          input.value = parseFloat(input.value) - 1;
          input.dispatchEvent(new Event('change'));
          updateQty();
        }
      });

      input.addEventListener('change', (e) => {
        updateQty();
      });
    });
  }

  reloadDrawer() {
    fetch(window.location.pathname + "?sections=cart-drawer")
      .then(response => {
        return response.json();
      })
      .then(response => {
        const drawerHTML = response['cart-drawer'];
        const parser = new DOMParser();
        const drawerContent = parser.parseFromString(drawerHTML, 'text/html');
        this.drawerInner.innerHTML = drawerContent.querySelector('.cart-drawer__inner').innerHTML;
        this.menuCartCount.innerHTML = drawerContent.querySelector('.cart-drawer__count').innerHTML;
        this.drawerTriggers();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  updateItem(formData) {
    this.loader(true);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(response.status) {
          new Notify({
            status: 'error',
            title: response.message,
            text: response.description,
            autoclose: false,
            autotimeout: 3000,
          })
        } else {
          this.reloadDrawer();
          this.openDrawer();
        }
        this.loader(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.loader(false);
      });
  }

  loader (loading) {
    if (loading) {
      this.drawer.classList.add('is-loading');
    } else {
      this.drawer.classList.remove('is-loading');
    }
  }

  openDrawer() {
    this.drawer.classList.add('is-open');
  }

  closeDrawer() {
    this.drawer.classList.add('is-closing');
    setTimeout(() => {
      this.drawer.classList.remove('is-closing');
      this.drawer.classList.remove('is-open');
    }, 400); // opacity transition duration
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new Shop();
});